var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8GuineaBissau(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd600",
    d: "M44,24c0-11.046-8.954-20-20-20c-0.675,0-1.342,0.036-2,0.101V24H44z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#388e3c",
    d: "M44,24H22v19.899C22.658,43.964,23.325,44,24,44C35.046,44,44,35.046,44,24z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#e53935",
    d: "M22,4.101C11.894,5.105,4,13.63,4,24c0,10.37,7.894,18.895,18,19.899V24V4.101z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M15.816,24.137L18.754,22h-3.633L14,18.547L12.879,22H9.246l2.938,2.137l-1.121,3.453L14,25.453 l2.937,2.137L15.816,24.137z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8GuineaBissau);
export default __webpack_public_path__ + "static/media/icons8-guinea-bissau.4baa9cd3645291dfbe387a77281fe8e1.svg";
export { ForwardRef as ReactComponent };